import React, { useContext, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import AppContext from 'context/Context';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const DropDownMenu = ({ locationData, dropdownDisabled, locationLoading }) => {
  const {
    setConfig,
    config: { isDark }
  } = useContext(AppContext);

  const tokenFromLocalStorage = localStorage.getItem('token');
  const decodedToken = jwtDecode(tokenFromLocalStorage);
  const tenant = decodedToken?.tenant_id;

  const { cluster } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isEvaluate = pathname.includes('evaluate');
  const isPlotOverlay = pathname.includes('plotoverlay');

  const [options, setOptions] = useState(null);

  const handleChange = ({ target }) => {
    setConfig('cluster', target.value);
    if (isPlotOverlay) {
      navigate(`/${tenant}/plotoverlay/${target.value}`);
    } else {
      navigate(
        `/${tenant}/${isEvaluate ? 'evaluate' : 'monitor'}/${target.value}`
      );
    }
  };

  useEffect(() => {
    if (locationLoading) {
      setOptions(<option disabled>Loading....</option>);
    } else if (isEmpty(locationData)) {
      setOptions(<option disabled>No clusters found.</option>);
    } else {
      setOptions(
        locationData.map(item => (
          <option key={item.key} value={item.key}>
            {item.value}
          </option>
        ))
      );
    }
  }, [locationData, dropdownDisabled, locationLoading]);

  return (
    <>
      <Form.Select
        name="cluster"
        disabled={dropdownDisabled}
        value={locationData.some(item => item.key === cluster) ? cluster : ''}
        onChange={handleChange}
      >
        <option key="blankChoice" hidden value>
          Select a Cluster
        </option>
        {options}
      </Form.Select>
    </>
  );
};

DropDownMenu.propTypes = {
  locationData: PropTypes.array.isRequired,
  dropdownDisabled: PropTypes.bool,
  locationLoading: PropTypes.bool
};

export default DropDownMenu;
